import { render, staticRenderFns } from "./recordPictures.vue?vue&type=template&id=1c29c7e5&"
import script from "./recordPictures.vue?vue&type=script&lang=js&"
export * from "./recordPictures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports